export class SwitchStatusTimes {
  regionId: number;
  dayFlag: number;
  cTodayEndTime: string;
  nTodayEndTime: number;
  cTomorrowStartTime: string;
  nTomorrowStartTime: number;
  activeFlag: number;
  regionName: string;
  dayFlagName: string;
  activeFlagName: string;

  constructor(json?: any) {
    if (!json) {
      return;
    }
    this.regionId = json.regionId;
    this.dayFlag = json.dayFlag;
    this.cTodayEndTime = json.cTodayEndTime;
    this.nTodayEndTime = json.nTodayEndTime;
    this.cTomorrowStartTime = json.cTomorrowStartTime;
    this.nTomorrowStartTime = json.nTomorrowStartTime;
    this.regionName = json.regionName;

    switch (this.dayFlag) {
      case 0:
        this.dayFlagName = 'Today';
        break;
      case 1:
        this.dayFlagName = 'Tomorrow';
        break;
      default:
        this.dayFlagName = 'Unknown';
        break;
    }

    switch (json.activeFlag) {
      case 0:
      case false:
        this.activeFlagName = 'Disabled';
        this.activeFlag = 0;
        break;
      case 1:
      case true:
        this.activeFlagName = 'Active';
        this.activeFlag = 1;
        break;
      default:
        this.activeFlagName = 'Unknown';
        this.activeFlag = -1;
        break;
    }
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/SwitchStatusTimes.ts